<div class="flex justify-between">
  <div class="flex flex-col">
    <div class="mat-subtitle-2 fw-600 fs-20 mt-4">{{'INSTANCE_SUMMARY.BACKUP_DETAILS' | transloco}}</div>
    <div class="subtitle mt-6">{{'INSTANCE_SUMMARY.SOURCE_ENVIRONMENT' | transloco}}: <span class="ml-4">{{details.sourceInstanceName}}</span></div>
  </div>
  <mat-icon svgIcon="close" class="icon-md-2 cursor-pointer" (click)="matdialogRef.close()"></mat-icon>
</div>
<mat-divider class="neutral-2 mb-16 mt-8"></mat-divider>
<div class="flex metrics-section">
  <div class="metrics">
    <div class="mat-subtitle-2 mb-0 fs-14 fw-700">{{'INSTANCE_SUMMARY.BACKUP_TYPE' | transloco}}</div>
    <div>{{details.backupType ? (details.backupType | titlecase) : '-'}}</div>
  </div>
  <div class="metrics">
    <div class="mat-subtitle-2 mb-0 fs-14 fw-700">{{'INSTANCE_SUMMARY.INTERVAL' | transloco}}</div>
    <div>{{details.backupInterval ? (details.backupInterval | titlecase) : '-'}}</div>
  </div>
  <div class="metrics">
    <div class="mat-subtitle-2 mb-0 fs-14 fw-700">{{'INSTANCE_SUMMARY.SERVER' | transloco}}</div>
    <div>{{details.serverName ? details.serverName : '-'}}</div>
  </div>
  <div class="metrics">
    <div class="mat-subtitle-2 mb-0 fs-14 fw-700">{{'INSTANCE_SUMMARY.DATABASE' | transloco}}</div>
    <div>{{details.databaseName ? details.databaseName : '-'}}</div>
  </div>
  <div class="metrics">
    <div class="mat-subtitle-2 mb-0 fs-14 fw-700">{{'INSTANCE_DETAILS.CREATED_DATE_UTC' | transloco}}</div>
    <div>{{details?.dbDetails?.createdAt | date: 'dd MMM yyyy, HH:mm' : 'UTC'}}</div>
  </div>
  <div class="metrics">
    <div class="mat-subtitle-2 mb-0 fs-14 fw-700">{{'INSTANCE_DETAILS.RETENTION_DATE_UTC' | transloco}}</div>
    <div>{{details?.dbDetails?.expirationDate | date: 'dd MMM yyyy'}} ({{details?.dbDetails?.expiryDays}} days)</div>
  </div>
  <div class="metrics">
    <div class="mat-subtitle-2 mb-0 fs-14 fw-700">{{'INSTANCE_DETAILS.SNAPSHOT_DATE_TIME' | transloco}}</div>
    <div>{{details?.dbDetails?.pitrTimestamp | date: 'dd MMM yyyy, HH:mm' : 'UTC'}}</div>
  </div>
  <div class="metrics">
    <div class="mat-subtitle-2 mb-0 fs-14 fw-700">{{'INSTANCE_DETAILS.JIRA_TICKET' | transloco}}</div>
    <div  [ngClass]="{'cursor-pointer clickable': details?.dbDetails?.ticketNumber}" (click)="ticketNumberClick(details?.dbDetails?.ticketNumber)">{{details?.dbDetails?.ticketNumber ? details?.dbDetails?.ticketNumber : '-'}}</div>
  </div>
  <div class="metrics">
    <div class="mat-subtitle-2 mb-0 fs-14 fw-700">{{details?.backupType === 'archive' ? ('INSTANCE_SUMMARY.FILE_NAME' | transloco) : details?.backupType === 'snapshot' ? ('INSTANCE_SUMMARY.DATABASE_NAME' | transloco) : details?.typeTag === 'PostgreSQL' ? ('INSTANCE_SUMMARY.SERVER_NAME' | transloco) : ('INSTANCE_SUMMARY.DATABASE_NAME' | transloco)}}</div>
    <div>{{details?.backupType === 'archive' && details?.dbDetails?.to?.fileName ? details?.dbDetails?.to?.fileName : details?.backupType === 'snapshot' && details?.dbDetails?.to?.databaseName ? details?.dbDetails?.to?.databaseName : details?.typeTag === 'PostgreSQL' && details?.dbDetails?.to?.serverName ? details?.dbDetails?.to?.serverName : 'N/A'}}</div>
  </div>
</div>